// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { PageInfoFragment } from '../../../../graphql/fragments/pageInfo.fragment.generated';
import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../../../graphql/fragments/pageInfo.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminTeamsPage_TeamFragment = { __typename?: 'Team', id: string, name: string, workosDirectoryGroupID?: string | null, assignedHouseholds: { __typename?: 'HouseholdConnection', totalCount: number }, employees: { __typename?: 'EmployeeConnection', totalCount: number } };

export type GetAdminTeamsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.TeamWhereInput>;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;


export type GetAdminTeamsQuery = { __typename?: 'Query', paginatedData: { __typename?: 'TeamConnection', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & PageInfoFragment
    ), edges?: Array<{ __typename?: 'TeamEdge', node?: (
        { __typename?: 'Team' }
        & AdminTeamsPage_TeamFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetAdminTeams: 'GetAdminTeams' as const
  },
  Fragment: {
    AdminTeamsPage_Team: 'AdminTeamsPage_Team' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AdminTeamsPage_TeamFragmentDoc = gql`
    fragment AdminTeamsPage_Team on Team {
  id
  name
  workosDirectoryGroupID
  assignedHouseholds {
    totalCount
  }
  employees {
    totalCount
  }
}
    `;
export const GetAdminTeamsDocument = gql`
    query GetAdminTeams($where: TeamWhereInput, $first: Int!, $after: Cursor) {
  paginatedData: teams(where: $where, first: $first, after: $after) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        ...AdminTeamsPage_Team
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${AdminTeamsPage_TeamFragmentDoc}`;

/**
 * __useGetAdminTeamsQuery__
 *
 * To run a query within a React component, call `useGetAdminTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminTeamsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAdminTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetAdminTeamsQuery, GetAdminTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminTeamsQuery, GetAdminTeamsQueryVariables>(GetAdminTeamsDocument, withFetchPolicyContext(options));
      }
export function useGetAdminTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminTeamsQuery, GetAdminTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminTeamsQuery, GetAdminTeamsQueryVariables>(GetAdminTeamsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetAdminTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminTeamsQuery, GetAdminTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminTeamsQuery, GetAdminTeamsQueryVariables>(GetAdminTeamsDocument, withFetchPolicyContext(options));
        }
export type GetAdminTeamsQueryHookResult = ReturnType<typeof useGetAdminTeamsQuery>;
export type GetAdminTeamsLazyQueryHookResult = ReturnType<typeof useGetAdminTeamsLazyQuery>;
export type GetAdminTeamsSuspenseQueryHookResult = ReturnType<typeof useGetAdminTeamsSuspenseQuery>;
export type GetAdminTeamsQueryResult = Apollo.QueryResult<GetAdminTeamsQuery, GetAdminTeamsQueryVariables>;